import { Plan } from '../../types/Plan';
import ApiClient from './ApiClient';
import { ApiRoute } from './ApiRoute';
import { getResponseData } from './adapterUtils';

class MembershipService {
  async getPlans() {
    const response = await ApiClient.get<Plan[]>(ApiRoute.PLANS);
    return getResponseData(response);
  }

  async getPlan(id: string) {
    const response = await ApiClient.get<Plan>(`${ApiRoute.PLANS}/${id}`);
    return getResponseData(response);
  }

  async createPlan(payload: Partial<Plan>) {
    const response = await ApiClient.post<{ id: string }>(`${ApiRoute.PLANS}`, { ...payload });
    return getResponseData(response);
  }

  async updatePlan(id: string, payload: Partial<Plan>) {
    const response = await ApiClient.patch<{ id: string }>(`${ApiRoute.PLANS}/${id}`, { ...payload });
    return getResponseData(response);
  }

  async deletePlan(id: string) {
    const response = await ApiClient.delete<void>(`${ApiRoute.PLANS}/${id}`);
    return getResponseData(response);
  }
}

export default new MembershipService();
